<template>
  <div class="app-footer">
    Copyright © Kakao Games Corp. All rights reserved.
    <div class="ml-auto compatable-info">
      본 사이트는 chrome 67버전 이상에 최적화되어 있습니다.
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
      }
    }
  }
</script>
<style scoped>
  .login .app-footer {
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px;
    margin-left: 0 !important;
  }
  .login .compatable-info {
    float: right;
  }
</style>
